export const PHRASE_BUILDER_STORAGE_KEY = 'yi.admin.phrase_builder_copy';
